export const RPC_SERVER = 'https://wax.greymass.com';